import { Button } from '@dasa-health/components-react'
import styled from 'styled-components'

export const CustomForm = styled.form`
    height: auto;
    max-width: 434px;

    .textInput > span {
        white-space: normal;
    }
`

export const CustomQUestionButton = styled(Button)`
    &&& {
        justify-content: flex-start;
        margin-left: 0;
        padding-left: 0;
        margin-top: -1rem;
        margin-bottom: -0.5rem;
    }
`

export const CustomButton = styled(Button)<{ $disabled?: boolean }>`
    &&& {
        background: ${({ disabled }) => (disabled ? '#16161614' : '#0037FF')};
        color: ${({ disabled }) => (disabled ? '#1616163D' : '#FEFEFE')};
        & img {
            margin-left: 1rem;
        }
    }
`
